import React from "react";

export const Loader = ({ size = "sm", color = "primary", className = "" }) => {
  const sizeClass = size === "sm" ? "spinner-border-sm" : size === "lg" ? "spinner-border" : "spinner-border-sm";
  return (
    <span
      className={`spinner-border ${sizeClass} text-${color} ${className}`.trim()}
      role="status"
      aria-hidden="true"
    />
  );
};
